import {
  ADD_RESET_PASSWORD_FIELD_ERROR,
  CHANGE_RESET_PASSWORD_FORM_FIELD,
  CLEAR_RESET_PASSWORD_FIELD_ERROR,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_REQUEST_FAILURE,
  RESET_PASSWORD_REQUEST_SUCCESS,
} from './actions'

export interface ResetPasswordState {
  formData: { password: string }
  resetEmailSuccessful: boolean
  errors: Record<string, string | undefined>
  loading: boolean
}

export const initialState = (): ResetPasswordState => ({
  formData: { password: '' },
  resetEmailSuccessful: false,
  errors: {},
  loading: false,
})

type Action =
  | ReturnType<typeof import('./actions').changeResetPasswordFormField>
  | ReturnType<typeof import('./actions').resetPasswordRequest>
  | ReturnType<typeof import('./actions').resetPasswordSuccess>
  | ReturnType<typeof import('./actions').resetPasswordFailure>
  | ReturnType<typeof import('./actions').addFieldError>
  | ReturnType<typeof import('./actions').clearFieldError>

export default function reducer(
  state: ResetPasswordState = initialState(),
  action: Action,
): ResetPasswordState {
  switch (action.type) {
    case CHANGE_RESET_PASSWORD_FORM_FIELD:
      return {
        ...state,
        formData: { ...state.formData, [action.payload.key]: action.payload.value },
      }
    case RESET_PASSWORD_REQUEST:
      return { ...state, loading: true, errors: {} }
    case RESET_PASSWORD_REQUEST_SUCCESS:
      return { ...state, resetEmailSuccessful: true, loading: false }
    case RESET_PASSWORD_REQUEST_FAILURE:
      return { ...state, loading: false, errors: action.errors }
    case ADD_RESET_PASSWORD_FIELD_ERROR:
      return { ...state, errors: { ...state.errors, [action.payload.field]: action.payload.error } }
    case CLEAR_RESET_PASSWORD_FIELD_ERROR:
      return { ...state, errors: { ...state.errors, [action.payload.field]: undefined } }
    default:
      return state
  }
}
